/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetTeamsTeam200Response
 */
export interface GetTeamsTeam200Response {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'orgAccountId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'teamsTeamId': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'teamsTeamName': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'status': GetTeamsTeam200ResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'tokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'latestTokenVersion': string;
    /**
     * 
     * @type {string}
     * @memberof GetTeamsTeam200Response
     */
    'tokenScope': string;
}

export const GetTeamsTeam200ResponseStatusEnum = {
    unknown: 'UNKNOWN',
    active: 'ACTIVE',
    inactive: 'INACTIVE',
    cancelled: 'CANCELLED',
    invalidated: 'INVALIDATED',
    suspended: 'SUSPENDED',
    pending: 'PENDING'
} as const;

export type GetTeamsTeam200ResponseStatusEnum = typeof GetTeamsTeam200ResponseStatusEnum[keyof typeof GetTeamsTeam200ResponseStatusEnum];


